import { render, staticRenderFns } from "./waitting-result.vue?vue&type=template&id=b8075b7e&scoped=true&"
import script from "./waitting-result.vue?vue&type=script&lang=js&"
export * from "./waitting-result.vue?vue&type=script&lang=js&"
import style0 from "./waitting-result.vue?vue&type=style&index=0&id=b8075b7e&scoped=true&lang=css&"
import style1 from "./waitting-result.vue?vue&type=style&index=1&id=b8075b7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8075b7e",
  null
  
)

export default component.exports